import { render, staticRenderFns } from "./MenuInscripcionPage.vue?vue&type=template&id=9c92e85a&scoped=true"
import script from "./MenuInscripcionPage.vue?vue&type=script&lang=js"
export * from "./MenuInscripcionPage.vue?vue&type=script&lang=js"
import style0 from "./MenuInscripcionPage.vue?vue&type=style&index=0&id=9c92e85a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c92e85a",
  null
  
)

export default component.exports